import MuiAppBar from '@mui/material/AppBar';
import { useContext } from 'react';

import { CustomizationInfo } from './CustomizationInfo';
import { MenuBarV2 } from './menu-bar-v2/MenuBarV2';
import { ApplicationContext } from '../../../../shared/source/context/context';
import { getTimeDeltaInDays } from '../../../../shared/source/date/date';
import { companyOnboardingRoutePath } from '../../company-onboarding/route-config';
import { TrialInformation, trialPeriodDays } from '../../purchase/TrialInformation';
import { route } from '../pages/onboarding/constants';

import type { FunctionComponent } from 'react';

const disableAppBarRoutes = [route.patterns.onboarding, companyOnboardingRoutePath];

export const AppBar: FunctionComponent = () => {
    const {
        applicationState: { customization, location },
    } = useContext(ApplicationContext);
    const { pathname } = location;

    if (disableAppBarRoutes.includes(pathname)) {
        return null;
    }

    const tenantCreatedAt = customization.get('tenantCreatedAt');
    const daysRemaining = tenantCreatedAt.mapOr(0, (createdAt) => {
        return Math.max(0, trialPeriodDays - getTimeDeltaInDays(new Date(), createdAt));
    });

    return (
        <MuiAppBar
            component="header"
            elevation={0}
            position="sticky"
            sx={{
                backgroundColor: 'background.default',
            }}
        >
            {customization
                .get('tenantMode')
                .mapOr(null, (mode) => (mode === 'trial' ? <TrialInformation daysRemaining={daysRemaining} /> : null))}
            <CustomizationInfo />
            <MenuBarV2 />
        </MuiAppBar>
    );
};
